import React from "react";
import { Route } from "react-router-dom";
import { LiveLogDemo, LiveLogsContainer } from "../LiveLogPage";

export const routes = [
  <Route key="container" path="/users/:userId/live_log" component={LiveLogsContainer} />,
  <Route key="demo" path="/live_log_demo" component={LiveLogDemo} />,
];
